import Box from '@mui/material/Box'
import type { SxProps, Theme } from '@mui/material/styles'
import type { ReactElement } from 'react'

import { colorTokens } from '../tokens/colors.ts'

const ADD_BUTTON_SX: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
  minHeight: colorTokens.table.header.height,
  margin: 0,
  padding: 0,
  border: 'none',
  background: 'none',
  cursor: 'pointer',
  color: colorTokens.text.bodyNeutral,
  '&:hover': {
    color: colorTokens.semantic.brand.primary,
    backgroundColor: colorTokens.global.primary[50]
  },
  '&:focus-visible': {
    outline: `2px solid ${colorTokens.global.primary[200]}`,
    outlineOffset: -2
  }
}

export type PropertyTableHeaderAddButtonProps = {
  readonly onAdd?: (anchor: HTMLElement) => void
  readonly ariaLabel?: string
}

/**
 * Trailing header control that opens the add-column flow from the table edge.
 */
export const PropertyTableHeaderAddButton = ({
  onAdd,
  ariaLabel = 'Add column'
}: PropertyTableHeaderAddButtonProps): ReactElement => (
  <Box
    component="button"
    type="button"
    aria-label={ariaLabel}
    data-testid="property-table-header-add-column"
    onClick={(event) => onAdd?.(event.currentTarget)}
    sx={ADD_BUTTON_SX}
  >
    <Box
      component="svg"
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      aria-hidden
      sx={{
        width: '16px',
        height: '16px',
        display: 'block',
        flexShrink: 0,
        color: 'currentColor'
      }}
    >
      <path
        d="M8 3.25v9.5M3.25 8h9.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </Box>
  </Box>
)
